import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { LoginView, AuthView, RegisteredView } from './Auth';
import { AccountView } from './Account';
import { inject, observer } from 'mobx-react/index';

class Theme extends Component {
    componentDidMount() {
        this.style = document.createElement('link');
        this.style.rel = 'stylesheet';
        this.style.href = `/${this.props.theme}.css`;
        document.head.appendChild(this.style);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.style.href = `/${this.props.theme}.css`;
    }

    render() {
        return this.props.children;
    }
}

@inject('store')
@observer
class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            runOnce: false
        };
    }

    componentDidMount() {
        const { store } = this.props;

        store.fbAuth.onAuthStateChanged(async user => {
            if (user && !this.state.runOnce) {
                try {
                    this.props.store.botStore.getUserBots();
                    await this.props.store.botConfigStore.getConfigurations();
                    this.props.store.strategyStore.getStrategies();
                    await this.props.store.userStore.getProfile();
                    this.setState({ runOnce: true });
                } catch (e) {
                    console.error(e);
                }
            }
        });
    }

    render() {
        return (
            <Theme theme={this.props.store.userStore.currentUser.theme}>
                <Switch>
                    <Route exact path="/auth" component={AuthView} />
                    <Route exact path="/registered" component={RegisteredView} />
                    <Route exact path="/" component={LoginView} />
                    <Route exact path="/login" component={LoginView} />
                    <Route exact path="/register" component={LoginView} />
                    <Route path="/a/" component={AccountView} />
                </Switch>
            </Theme>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js